module.exports = __webpack_public_path__ + "img/obucenie.d9e6d411.png";